(function ($) {
	class ULMC {
		constructor() {
			this.widgetClass = ".ultimate-loan-mortgage-calculator";
			this.result = {};
			this.data = {};
			this.calculatorID = 0;
		}

		init() {
			const calculator = $(this.widgetClass);
			this.calculatorID = calculator.attr("id");

			this.dateInit();
			this.setCalculatorData();
			this.selectInit();
			this.customNumberInputInit();
			this.switchInit();
			this.setCssVariables();
			this.showHelp();
			this.showScheduleTable();
			this.changeOptions();
			this.sendEmail();
			this.calculateResult();

			if ($(calculator).length) {
				$("body").addClass("ultimate-loan-mortgage-calculator-page");
			}
		}

		customNumberInputInit() {
			if ($.fn.numberstyle) {
				if ($(".ulmc_loan_balance").length) {
					$(".ulmc_loan_balance").numberstyle();
				}
				if ($(".ulmc_interest_rate").length) {
					$(".ulmc_interest_rate").numberstyle();
				}
				if ($(".ulmc_term_years").length) {
					$(".ulmc_term_years").numberstyle();
				}
				if ($(".ulmc_term_months").length) {
					$(".ulmc_term_months").numberstyle();
				}
				if ($(".ulmc_down_payment").length) {
					$(".ulmc_down_payment").numberstyle();
				}
			}
		}

		setCalculatorData() {
			const calculator = $(this.widgetClass);

			this.data.acceptance = +calculator.find("[name=ulmc_user_acceptance]").val();

			this.data.loanBalance = +calculator.find(".ulmc_loan_balance").val();

			let interestRate = +calculator.find(".ulmc_interest_rate").val();
			this.data.baseInterestRate = interestRate;
			this.data.interestRate = interestRate / 100;
			this.data.downPayment = +calculator.find(".ulmc_down_payment").val();

			this.data.termYears = calculator.find(".ulmc_term_years").val() ? +calculator.find(".ulmc_term_years").val() : 0;
			this.data.termMonths = calculator.find(".ulmc_term_months").val() ? +calculator.find(".ulmc_term_months").val() : 0;
			this.data.totalMonths = this.data.termYears * 12 + this.data.termMonths;

			this.data.firstPaymentDate = calculator.find(".ulmc_date_payment").datepicker("getDate");

			this.data.paymentFrequency = "monthly";
			this.data.paymentsPerYear = 12;

			const currencySymbol = calculator.find(".ulmc_currency_symbol");
			this.data.currency = currencySymbol.text();
			this.data.currencyCode = currencySymbol.attr("data-currency");
		}

		selectInit() {
			if ($.fn.customSelect) {
				const ulmc = this;
				$(".ulmc_payment_frequency").customSelect({
					block: "ulmc-select",
					includeValue: true,
					hideCallback: function () {
						ulmc.setCalculatorData();
						ulmc.calculateResult();
					},
				});
			}
		}

		dateInit() {
			const ulmc = this;
			const today = new Date();
			const dateFormat = $(".ulmc_date_payment").attr("data-format");
			this.data.date_format = dateFormat;

			var formattedDate = $.datepicker.formatDate(dateFormat, today);

			$(".ulmc_date_payment").val(formattedDate);

			$(".ulmc_date_payment").datepicker({
				dateFormat: dateFormat,
				defaultDate: today,
				onSelect: function (dateText, inst) {
					ulmc.data.firstPaymentDate = $(this).datepicker("getDate");
					ulmc.calculateResult();
				},
			});
		}

		changeOptions() {
			const ulmc = this;
			const calculator = $(this.widgetClass);

			$(".ulmc_term_years, .ulmc_term_months").on("change", ulmc.adjustTermFields);
			$(".ulmc_term_years, .ulmc_term_months").on("blur", ulmc.adjustTermFields);

			// Update result count after changing fields.
			$(".ulmc-settings input").on("change", function () {
				ulmc.setCalculatorData();
				ulmc.calculateResult();
			});
		}

		calculateResult() {
			const data = this.data;

			if (!data.loanBalance || !data.interestRate) return 0;

			if (!data.totalMonths) {
				return 0;
			}

			// Adjust loan balance by subtracting down payment
			const adjustedLoanBalance = data.loanBalance - (data.downPayment || 0);

			var periodicInterestRate = data.interestRate / data.paymentsPerYear;
			var numberOfPayments = (data.totalMonths / 12) * data.paymentsPerYear;

			var paymentAmount = (adjustedLoanBalance * periodicInterestRate) / (1 - Math.pow(1 + periodicInterestRate, -numberOfPayments));

			this.result.numberOfPayments = numberOfPayments;
			this.result.paymentAmount = paymentAmount.toFixed(2);

			var totalCost = this.result.paymentAmount * numberOfPayments;
			this.result.totalCost = totalCost.toFixed(2);

			var totalInterest = this.result.totalCost - adjustedLoanBalance;
			this.result.totalInterest = totalInterest.toFixed(2);

			this.updateCounter();
			this.updateScheduleTable();
		}

		calculateSchedule() {
			// Adjust loan balance by subtracting down payment
			let balance = this.data.loanBalance - (this.data.downPayment || 0);
			let schedule = [];
			let firstPaymentDate = "";

			if (this.data.firstPaymentDate) {
				firstPaymentDate = new Date(this.data.firstPaymentDate.getTime());
			}

			let monthsInterval = 12 / this.data.paymentsPerYear;

			for (let i = 1; i <= this.result.numberOfPayments; i++) {
				let interestPayment = (balance * this.data.interestRate) / this.data.paymentsPerYear;
				let principalPayment = this.result.paymentAmount - interestPayment;

				if (i === this.result.numberOfPayments) {
					principalPayment = balance;
				}

				let closingBalance = balance - principalPayment;

				let formattedPaymentDate = firstPaymentDate ? $.datepicker.formatDate(this.data.date_format, firstPaymentDate) : "";

				schedule.push({
					paymentNumber: i,
					paymentDate: formattedPaymentDate,
					openingBalance: balance.toFixed(2),
					principalPayment: principalPayment.toFixed(2),
					interestPayment: interestPayment.toFixed(2),
					closingBalance: closingBalance.toFixed(2),
				});

				balance = closingBalance;

				if (firstPaymentDate) {
					firstPaymentDate.setMonth(firstPaymentDate.getMonth() + monthsInterval);
				}
			}

			// Ensure the final balance is exactly 0
			if (Math.abs(balance) < 0.01) {
				schedule[schedule.length - 1].closingBalance = "0.00";
			}

			return schedule;
		}

		createScheduleTable(schedule) {
			const ulmc = this;
			let scheduleHTML = "";
			schedule.forEach((row) => {
				scheduleHTML += "<tr>";
				scheduleHTML += "<td>" + row.paymentNumber + "</td>";
				scheduleHTML += "<td>" + row.paymentDate + "</td>";
				scheduleHTML += "<td>" + ulmc.formatMoneyValue(+row.openingBalance) + "</td>";
				scheduleHTML += "<td>" + ulmc.formatMoneyValue(+row.principalPayment) + "</td>";
				scheduleHTML += "<td>" + ulmc.formatMoneyValue(+row.interestPayment) + "</td>";
				scheduleHTML += "<td>" + ulmc.formatMoneyValue(+row.closingBalance) + "</td>";
				scheduleHTML += "</tr>";
			});
			return scheduleHTML;
		}

		updateScheduleTable() {
			$(".ulmc_schedule_table tbody").html("");
			$(".ulmc_principal_heading").text(this.data.paymentFrequency + " Principal");
			$(".ulmc_interest_heading").text(this.data.paymentFrequency + " Interest");

			const schedule = this.calculateSchedule();
			this.result.scheduleHTML = this.createScheduleTable(schedule);

			$(".ulmc_schedule_table tbody").append(this.result.scheduleHTML);
		}

		updateCounter() {
			const calculator = $(this.widgetClass);

			const elements = {
				paymentAmount: calculator.find(".ulmc_result_payment_amount"),
				totalCost: calculator.find(".ulmc_result_total_cost"),
				totalInterest: calculator.find(".ulmc_result_total_interest"),
			};

			const result = this.result;

			this.animateCounter(elements.paymentAmount, result.paymentAmount);
			this.animateCounter(elements.totalCost, result.totalCost);
			this.animateCounter(elements.totalInterest, result.totalInterest);
		}

		animateCounter(element, value) {
			if (element.length && value && value > 0) {
				jQuery({ Counter: 0 }).animate(
					{ Counter: value },
					{
						duration: 400,
						easing: "swing",
						step: function (now) {
							element.text(Math.ceil(now));
						},
						done: function () {
							element.text(ulmc.formatMoneyValue(this.Counter, ulmc.data.currency));
						},
					}
				);
			}
		}

		sendEmail() {
			const ulmc = this;

			$(".ulmc_send_result")
				.off()
				.click(function (e) {
					e.preventDefault();
					const form = $(this).closest("form");
					ulmc.formSubmit(form, ".ulmc_send_result");
				});
		}

		formSubmit(form, submitButton) {
			const ulmc = this;
			const calculator = form.parents(ulmc.widgetClass);

			// Calculator Fields data.
			const dataResult = {
				loan_balance: this.formatMoneyValue(+this.data.loanBalance, ulmc.data.currency),
				interest_rate: this.data.baseInterestRate,
				loan_term_years: this.data.termYears,
				loan_term_months: this.data.termMonths ? this.data.termMonths : 0,
				payment_frequency: this.data.paymentFrequency,
				first_payment_date: this.data.firstPaymentDate ? $.datepicker.formatDate(this.data.date_format, this.data.firstPaymentDate) : "",
				down_payment: this.formatMoneyValue(this.data.downPayment, ulmc.data.currency),
				number_of_payments: this.result.numberOfPayments,
				payment_amount: this.formatMoneyValue(+this.result.paymentAmount, ulmc.data.currency),
				total_cost: this.formatMoneyValue(+this.result.totalCost, ulmc.data.currency),
				total_interest: this.formatMoneyValue(+this.result.totalInterest, ulmc.data.currency),
				schedule: this.result.scheduleHTML,
			};

			// Form Data.
			const userEmail = calculator.find(".ulmc_user_email").length ? calculator.find(".ulmc_user_email").val() : "";

			const data = {
				action: "ulmc_send_result",
				submit_button: submitButton,
				user_email: userEmail,
				data: JSON.stringify(dataResult),
				nonce: $("#ulmc_nonce_" + this.calculatorID).val(),
				calculator_id: this.calculatorID,
			};

			// Form Validation.
			const validForm = ulmc.formValidate(calculator);

			// Ajax Response.
			if (validForm["filled_fields"] && validForm["required_fields"] && validForm["valid_fields"] && validForm["acceptance"]) {
				form.find(submitButton).addClass("ulmc-loading");
				ulmc.ajaxResponse(form, data);
			} else {
				$.each(validForm, function (key, value) {
					ulmc.displayError(calculator, key, value);
				});
			}
		}

		formValidate(calculator) {
			const validForm = {
				filled_fields: true,
				required_fields: true,
				valid_fields: true,
				acceptance: true,
			};

			// Validate Empty Calculator Fields.
			validForm["filled_fields"] = ulmc.validateCalculatorFields(calculator);

			calculator.find(".ulmc-metric input").on("keyup", function () {
				const calculator = $(this).parents(ulmc.widgetClass);

				validForm["filled_fields"] = ulmc.validateCalculatorFields(calculator);
				ulmc.displayError(calculator, "filled_fields", validForm["filled_fields"]);
			});

			// Validate User Form Required Fields.
			validForm["required_fields"] = ulmc.validateFormFields(calculator);

			calculator.find(".ulmc-result-form-field").on("keyup", function () {
				const calculator = $(this).parents(ulmc.widgetClass);

				validForm["required_fields"] = ulmc.validateFormFields(calculator);

				ulmc.displayError(calculator, "required_fields", validForm["required_fields"]);
			});

			// Validate User form Values (email).
			validForm["valid_fields"] = ulmc.validateFormValues(calculator);

			calculator.find(".ulmc-result .ulmc-validate").on("focusout", function () {
				const calculator = $(this).parents(ulmc.widgetClass);
				validForm["valid_fields"] = ulmc.validateFormValues(calculator);

				ulmc.displayError(calculator, "valid_fields", validForm["valid_fields"]);
			});
			calculator.find(".ulmc-result .ulmc-validate").on("keyup", function () {
				const calculator = $(this).parents(ulmc.widgetClass);

				validForm["valid_fields"] = ulmc.validateFormValues(calculator);

				if (true == validForm["valid_fields"]) {
					ulmc.displayError(calculator, "valid_fields", validForm["valid_fields"]);
				}
			});

			// Validate User Acceptance.
			validForm["acceptance"] = ulmc.validateAcceptance(calculator);

			calculator.find(".ulmc-checkbox--privacy input").on("change", function () {
				validForm["acceptance"] = ulmc.validateAcceptance(calculator);
				ulmc.displayError(calculator, "acceptance", validForm["acceptance"]);
			});

			return validForm;
		}

		ajaxResponse(form, data) {
			const ulmc = this;

			var calculator = form.parents(ulmc.widgetClass);

			$.post(window.ulmc_vars.ajaxurl, data, function (response) {
				form.find("button").removeClass("ulmc-loading");

				if (response.success) {
					ulmc.addNotice(calculator, "success", "send_success", response.data.success_message);
					calculator.find(".ulmc_user_email").val("");
					form.find(".ulmc_send_result").removeClass("ulmc-loading");
					form.slideUp();
				}
			});
		}

		validateCalculatorFields(calculator) {
			let valid = [];

			const fields = {
				loan_balance: calculator.find(".ulmc_loan_balance").val(),
				interest_rate: calculator.find(".ulmc_interest_rate").val(),
			};

			$.each(fields, function (key, value) {
				if (!value || "" === value) {
					valid[key] = false;
					calculator.find(".ulmc_" + key).addClass("ulmc-empty");
				} else {
					valid[key] = true;
					calculator.find(".ulmc_" + key).removeClass("ulmc-empty");
				}
			});

			const term_fields = {
				years: calculator.find(".ulmc_term_years").val() ? +calculator.find(".ulmc_term_years").val() : 0,
				months: calculator.find(".ulmc_term_months").val() ? +calculator.find(".ulmc_term_months").val() : 0,
			};

			if (!term_fields.years && !term_fields.months) {
				calculator.find(".ulmc_term_years").addClass("ulmc-empty");
				calculator.find(".ulmc_term_months").addClass("ulmc-empty");
				valid["term"] = false;
			} else {
				calculator.find(".ulmc_term_years").removeClass("ulmc-empty");
				calculator.find(".ulmc_term_months").removeClass("ulmc-empty");
				valid["term"] = true;
			}

			return Object.values(valid).every(Boolean);
		}

		adjustTermFields() {
			var yearsField = $(".ulmc_term_years");
			var monthsField = $(".ulmc_term_months");

			var months = parseInt(monthsField.val());
			var years = parseInt(yearsField.val());

			if (months >= 12) {
				var additionalYears = Math.floor(months / 12);
				var remainingMonths = months % 12;

				years += additionalYears;
				months = remainingMonths;

				yearsField.val(years);
				monthsField.val(months);
			}
		}

		validateFormFields(calculator) {
			let valid = [];
			let validField = true;
			const field = calculator.find(".ulmc-save-result__form-field");

			field.each(function () {
				const requiredData = $(this).attr("required") ? true : false;

				const fieldName = $(this).attr("name");
				const fieldValue = $(this).val();

				if (requiredData && "" === fieldValue) {
					$(this).addClass("ulmc-save-result__form-field--error");
					valid[fieldName] = false;
				} else {
					valid[fieldName] = true;

					if (!$(field).hasClass("ulmc-validate")) {
						$(this).removeClass("ulmc-save-result__form-field--error");
					} else {
						validField = ulmc.validateFormValues(calculator);
						if (validField) {
							$(this).removeClass("ulmc-save-result__form-field--error");
						} else {
							$(this).addClass("ulmc-save-result__form-field--error");
						}
					}
				}
			});

			return Object.values(valid).every(Boolean);
		}

		validateFormValues(calculator) {
			let valid = [];

			const field = calculator.find(".ulmc-result .ulmc-validate");

			field.each(function () {
				const fieldName = $(this).attr("name");
				const fieldValue = $(this).val();
				let regex = "";

				switch (fieldName) {
					case "email":
						regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
						break;
				}

				if (fieldValue !== "" && regex.test(fieldValue)) {
					$(this).removeClass("ulmc-save-result__form-field--error");
					valid[fieldName] = true;
				} else if (fieldValue !== "" && !regex.test(fieldValue)) {
					valid[fieldName] = false;
				}
			});

			return Object.values(valid).every(Boolean);
		}

		validateAcceptance(calculator) {
			let validated = true;

			const acceptance = calculator.find("input[name=ulmc_user_acceptance]");

			if (acceptance.length) {
				if (!acceptance.is(":checked")) {
					validated = false;
					calculator.find(".ulmc-checkbox--privacy").addClass("ulmc-empty");
				} else {
					validated = true;
					calculator.find(".ulmc-checkbox--privacy").removeClass("ulmc-empty");
				}
			} else {
				validated = true;
			}

			return validated;
		}

		switchInit() {
			$(".ulmc-switch-option").click(function () {
				const position = $(this).data("position"),
					input = $(this).parent().find("input");

				if (position == "left") {
					input.prop("checked", false);
					input.trigger("change");
				} else {
					input.prop("checked", true);
					input.trigger("change");
				}
			});
		}

		showHelp() {
			$(".ulmc-note__open").click(function () {
				const helpId = $(this).parent().attr("data-id");
				$("#" + helpId).slideToggle();
			});
			$(".ulmc-note__close").click(function () {
				$(this).parent().slideUp();
			});
		}

		showScheduleTable() {
			const ulmc = this;
			const calculator = $(ulmc.widgetClass);

			$(".ulmc-schedule__show").click(function () {
				const sheduleTable = calculator.find(".ulmc-schedule");

				if (sheduleTable.hasClass("active")) {
					sheduleTable.removeClass("active");
					sheduleTable.slideUp();
					$(this).text(window.ulmc_vars.i18n.showScheduleButtonText);
				} else {
					sheduleTable.addClass("active");
					sheduleTable.slideDown();
					$(this).text(window.ulmc_vars.i18n.hideScheduleButtonText);
					$("html, body").animate({ scrollTop: sheduleTable.offset().top - 50 }, 1200);
				}
			});
		}

		addHTMLNotice(calculator, type, notice, message) {
			const noticeContainer = calculator.find(".ulmc-result-form-notices");

			const noticeHTML = '<div class="ulmc-result-form-notice ulmc-result-form-notice--' + type + " ulmc-result-form-notice--" + notice + '  ulmc-show">' + message + "</div>";

			noticeContainer.append(noticeHTML);

			noticeContainer.find(".ulmc-result-form-notice--" + notice).slideDown(
				{
					direction: "up",
				},
				400
			);
		}

		addNotice(calculator, type, notice, message) {
			const noticeContainer = calculator.find(".ulmc-save-result__form-notices");

			const noticeHTML = '<div class="ulmc-save-result__form-notice ulmc-save-result__form-notice--' + type + " ulmc-save-result__form-notice--" + notice + '  ulmc-show"><span>' + message + "</span></div>";

			noticeContainer.append(noticeHTML);

			noticeContainer.find(".ulmc-save-result__form-notice--" + notice).slideDown(
				{
					direction: "up",
				},
				400
			);
		}

		removeNotice(calculator, notice) {
			const noticeEl = calculator.find(".ulmc-save-result__form-notice--" + notice);
			if (noticeEl.hasClass("ulmc-show")) {
				noticeEl.removeClass("ulmc-show");
				noticeEl.slideUp(
					{
						direction: "down",
					},
					400
				);
				setTimeout(function () {
					noticeEl.remove();
				}, 400);
			}
		}

		displayError(calculator, key, value) {
			const noticeEl = $(".ulmc-save-result__form-notice--" + key);
			let message;

			switch (key) {
				case "filled_fields":
					message = window.ulmc_vars.i18n.emptyFields;
					break;
				case "required_fields":
					message = window.ulmc_vars.i18n.emptyRequiredFields;
					break;
				case "valid_fields":
					message = window.ulmc_vars.i18n.invalidFields;
					break;
				case "acceptance":
					message = window.ulmc_vars.i18n.acceptanceMessage;
					break;
			}

			if (!noticeEl.length && !value) {
				ulmc.addNotice(calculator, "error", key, message);

				if ("filled_fields" === key) {
					const metricFields = calculator.find(".ulmc-empty");
					if (metricFields.length) {
						$("html, body").animate({ scrollTop: metricFields.offset().top - 50 }, 1200);
					}
				}
			} else if (noticeEl.length && true == value) {
				ulmc.removeNotice(calculator, key);
			}
		}

		setCssVariables() {
			const calculator = $(this.widgetClass);
			const ulmc = this;
			calculator.each(function () {
				let calculatorColors = $(this).data("colors");
				let fontSize = $(this).data("font-size");
				document.documentElement.style.setProperty("--ulmc-font-size", fontSize);
				if (calculatorColors) {
					for (let key in calculatorColors) {
						let keyrgb = ulmc.convertColorHexToRgb(calculatorColors[key]);
						document.documentElement.style.setProperty("--ulmc-" + key, keyrgb);
					}
				}
			});
		}

		formatMoneyValue(value, currency = "") {
			let formattedNum = "";

			const options = {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			};

			if (currency && "" !== currency) {
				formattedNum += currency + "\u2009";
			}

			formattedNum += value.toLocaleString("en-US", options);
			return formattedNum;
		}

		convertColorHexToRgb(color) {
			if (color.substring(0, 1) == "#") {
				color = color.substring(1);
			}

			// Ensure the color is 6 characters long
			if (color.length === 3) {
				color = color
					.split("")
					.map((c) => c + c)
					.join("");
			}

			let rgbColor;
			rgbColor = parseInt(color.substring(0, 2), 16) + "," + parseInt(color.substring(2, 4), 16) + "," + parseInt(color.substring(4), 16);

			return rgbColor;
		}

		fixGutenbergBlock() {
			let calculatorReady = false;
			const ulmc = this;
			let calculatorReadyInterval = setInterval(function () {
				if (document.querySelector(ulmc.widgetClass)) {
					ulmc.setCssVariables();

					calculatorReady = true;
				}
				if (calculatorReady) {
					clearInterval(calculatorReadyInterval);
				}
			}, 500);
		}

		removeEmptyParagraphs() {
			const calculator = $(this.widgetClass);

			if (!calculator.length) return;

			calculator.find("p").each(function () {
				const p = $(this);
				const isEffectivelyEmpty = p.html().trim() === "" || p.html().trim() === "<br>" || p.html().trim() === "<br />" || p.text().trim() === "";

				if (isEffectivelyEmpty) {
					p.remove();
				}
			});

			calculator.find("br").each(function () {
				const br = $(this);
				br.remove();
			});
		}
	}

	// Calculator Init.
	window.ulmc = new ULMC();
	ulmc.init();

	// Twenty Twenty Four adds empty paragraphs and line breaks in the calculator container. Clean up empty paragraphs after initialization, with a slight delay.
	setTimeout(function () {
		ulmc.removeEmptyParagraphs();
	}, 100);
})(jQuery);
